import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'booth',
    serviceName: 'shopadmin',
    query: gql`
      query booth($ids: [String]) {
        booth(ids: $ids) {
          data {
            id
            title
            media {
              id
              full_url
            }
          }
        }
      }
    `,
  },
};

export default schema;
